
declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

type MetaPixelFunction = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: MetaPixelFunction
  loaded?: boolean
  version?: string
}

const META_PIXEL_ID = '1580160920437567'
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script'

export function initializeMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: MetaPixelFunction = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }
    fbq.queue?.push(args)
  }

  window.fbq = fbq
  window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.id = META_PIXEL_SCRIPT_ID
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  window.fbq?.('track', 'AddToCart', {
    content_ids: ['59627726569758'],
    content_type: 'product',
    value: 14999,
    currency: 'ARS',
  })
}
